import React from 'react';
import { useFeatures } from '../../hooks/useAdminData';
import { FaTruck, FaStar, FaHeart, FaBolt, FaHome, FaPaw } from 'react-icons/fa';
import './About.scss';

const About: React.FC = () => {
  const features = useFeatures();
  
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="about" className="about">
      <div className="container">
        <div className="about-header">
          <h2 className="about-title">
            <span className="highlight-text">ABOUT</span> US
          </h2>
          <p className="about-subtitle">Quality Care for Every Pet, Every Time.</p>
        </div>
        
        <div className="about-content">
          <div className="about-description">
            <p>
              Premium Pets Mobile brings luxury, cage-free grooming directly to your doorstep, with certified groomers, personalized services, and no waiting. We ensure comfort, safety, and loving attention for every pet, making every visit stress-free and enjoyable.
            </p>
          </div>
        </div>
      </div>
      
      {/* Feature Rows */}
      <div className="features-list">
        {features.map((feature, index) => (
          <div key={feature.id} className={`feature-row ${index % 2 === 0 ? 'even' : 'odd'}`}>
            <div className="container">
              <div className="feature-image">
                <img src={getFeatureImage(feature.id)} alt={feature.title} />
              </div>
              <div className="feature-content">
                <div className={`feature-icon delay-${index}`}>
                  {getFeatureIcon(feature.icon)}
                </div>
                <h3 className="feature-title">{feature.title}</h3>
                <p className="feature-description">{feature.description}</p>
                <button className="feature-btn" onClick={() => scrollToSection('contact')} aria-label="Learn more about this feature">
                  Learn More
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

const getFeatureIcon = (iconType: string) => {
  switch (iconType) {
    case 'van':
      return FaTruck({ size: 32 });
    case 'star':
      return FaStar({ size: 32 });
    case 'heart':
      return FaHeart({ size: 32 });
    case 'lightning':
      return FaBolt({ size: 32 });
    case 'house':
      return FaHome({ size: 32 });
    case 'paw':
      return FaPaw({ size: 32 });
    default:
      return null;
  }
};

const getFeatureImage = (featureId: string) => {
  switch (featureId) {
    case 'mobile':
      return '/assets/images/photo-mobile.webp';
    case 'premium-products':
      return '/assets/images/photo-premium-products.webp';
    case 'caring':
      return '/assets/images/photo-caring.webp';
    case 'custom':
      return '/assets/images/photo-custom.webp';
    case 'cage-free':
      return '/assets/images/photo-cage-free.webp';
    case 'family-owned':
      return '/assets/images/photo-family-owned.webp';
    default:
      return '/assets/images/photo-1.jpg';
  }
};

export default About;
